import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startSollstellungSimulationStatus: 'idle',
    startSollstellungSimulationError: undefined as any,
    loadUserParamsSollstellungSimulationStatus: 'idle',
    loadUserParamsSollstellungSimulationError: undefined as any,

    sollstellungSimulationList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startSollstellungSimulation = createAsyncThunk('sollstellungSimulationSlice/startSollstellungSimulation', async ({ sollstellungSimulation }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartSollstellungSimulation/`,
        prepareData(sollstellungSimulation),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startSollstellungSimulationStatus } = getState().sollstellungSimulationSlice
        return startSollstellungSimulationStatus !== 'pending'
    }
})

export const loadUserParamsSollstellungSimulation = createAsyncThunk('sollstellungSimulationSlice/loadUserParamsSollstellungSimulation', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsSollstellungSimulation/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsSollstellungSimulationStatus } = getState().sollstellungSimulationSlice
        return loadUserParamsSollstellungSimulationStatus !== 'pending'
    }
})

const SollstellungSimulationSlice = createSlice({
    name: 'sollstellungSimulationSlice',
    initialState,
    reducers: {
        resetstartSollstellungSimulation: (state) => {
            state.job = undefined
            state.startSollstellungSimulationError = undefined
        },
        resetstartSollstellungSimulationError: (state) => {
            state.startSollstellungSimulationError = undefined
        },
        resetloadUserParamsSollstellungSimulation: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsSollstellungSimulationError = undefined
        },
        resetloadUserParamsSollstellungSimulationError: (state) => {
            state.loadUserParamsSollstellungSimulationError = undefined
        },
        removeFromSollstellungSimulationListById: (state, action) => {
            state.sollstellungSimulationList = state.sollstellungSimulationList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromSollstellungSimulationListByIds: (state, action) => {
            state.sollstellungSimulationList = state.sollstellungSimulationList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.sollstellungSimulationList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startSollstellungSimulationStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.sollstellungSimulationList = []
            state.startSollstellungSimulationStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startSollstellungSimulation.pending, (state) => {
            state.startSollstellungSimulationStatus = 'pending'
            state.startSollstellungSimulationError = undefined
        })
        builder.addCase(startSollstellungSimulation.fulfilled, (state, action) => {
            state.startSollstellungSimulationStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startSollstellungSimulation.rejected, (state, action) => {
            state.startSollstellungSimulationStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startSollstellungSimulationError = action.error.message
            } else {
                state.startSollstellungSimulationError = action.payload
            }
        })

        builder.addCase(loadUserParamsSollstellungSimulation.pending, (state) => {
            state.loadUserParamsSollstellungSimulationStatus = 'pending'
            state.loadUserParamsSollstellungSimulationError = undefined
        })
        builder.addCase(loadUserParamsSollstellungSimulation.fulfilled, (state, action) => {
            state.loadUserParamsSollstellungSimulationStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsSollstellungSimulation.rejected, (state, action) => {
            state.loadUserParamsSollstellungSimulationStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsSollstellungSimulationError = action.error.message
            } else {
                state.loadUserParamsSollstellungSimulationError = action.payload
            }
        })

    }
})

export const {
    resetstartSollstellungSimulation,
    resetstartSollstellungSimulationError,
    resetloadUserParamsSollstellungSimulation,
    resetloadUserParamsSollstellungSimulationError,
    removeFromSollstellungSimulationListById,
    removeFromSollstellungSimulationListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = SollstellungSimulationSlice.actions
export default SollstellungSimulationSlice.reducer
